import React, { useEffect, useState } from "react";

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../assets/css/addunit.css";
import "../../assets/css/mainMenu.css";

import { useNavigate } from "react-router-dom";
import close from "../../assets/icons/close.svg";
import edit from "../../assets/icons/edit.svg";
import plus1 from "../../assets/icons/plus1.svg";
import recyclebin from "../../assets/icons/recycle-bin2.svg";
import search2 from "../../assets/icons/search2.svg";
import ArrowDown from "../../assets/icons2/ArrowDown.svg";
import ArrowUp from "../../assets/icons2/ArrowUp.svg";
import Loader from "../../Components/LoaderAndSpinner/Loader";
import Pagination from "../../Components/Pagination/Pagination";
import { hasPermission } from "../../Services/authUtils";

// import { FaPlus, FaEdit, FaArrowDown, FaArrowUp } from "react-icons/fa";
import fetchWrapper from "../../AuthMiddleware/FetchWrapper";
const Role = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [roleGroups, setRoleGroups] = useState([]);
  const [selectedRoleGroup, setSelectedRoleGroup] = useState("");
  const [roles, setRoles] = useState([]);

  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [confirmModal, setConfirmModal] = useState(false);
  const [actionType, setActionType] = useState(null);
  const [actionRoleId, setActionRoleId] = useState(null);
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [sortBy, setSortBy] = useState({
    field: "role_code",
    order: "asc",
  });
  const [statusFilter, setStatusFilter] = useState("");
  const [search, setSearch] = useState("");
  const [totalPages, setTotalPages] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalItems, setTotalItems] = useState(0);
  const [allChecked, setAllChecked] = useState(false);
  const [checkedItems, setCheckedItems] = useState([]);
  const [bulkDeleteModal, setBulkDeleteModal] = useState(false);
  const [errors, setErrors] = useState({});
  const startIndex = (page - 1) * pageSize + 1;
  const endIndex = Math.min(page * pageSize, totalItems);

  const [newRole, setNewRole] = useState({
    role_group_id: "",
    role_code: "",
    role_name: "",
  });

  const [selectedRole, setSelectedRole] = useState(null);

  // Fetch role groups data from the server
  const fetchRoleGroups = async () => {
    try {
      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/role-groups/getall`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        },
        navigate // Pass navigate here
      );

      if (data && Array.isArray(data.roleGroups)) {
        setRoleGroups(data.roleGroups);
      } else {
        throw new Error("Invalid data format");
      }
    } catch (error) {
      console.error("Error fetching role groups:", error);
      // setError(error.message);
    }
  };

  // Fetch roles for the selected role group
  const fetchRoles = async () => {
    try {
      const queryString = `?page=${page}&limit=${pageSize}&sortBy=${sortBy.field}&order=${sortBy.order}&search=${search}&status=${statusFilter}`;
      const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/role/pagination${queryString}`;

      const data = await fetchWrapper(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ role_group_id: selectedRoleGroup }),
        },
        navigate
      ); // Pass navigate here

      if (data) {
        setRoles(data.roles || []);
        setTotalPages(data.totalPages);
        setCurrentPage(data.currentPage);
        setTotalItems(data.totalItems);
      } else {
        throw new Error("No data received from server");
      }
    } catch (error) {
      console.error("Error fetching roles:", error);
      // Handle error as needed
    }
  };
  const handleSortChange = (field) => {
    setSortBy((prevSort) => ({
      field,
      order:
        prevSort.field === field && prevSort.order === "asc" ? "desc" : "asc",
    }));
  };

  const handleSearchChange = (event) => {
    setSearch(event.target.value);
    setPage(1);
  };

  const toggleDropdown = () => {
    setDropdownOpen(!isDropdownOpen);
  };

  const handlePageChange = (page) => {
    if (page >= 1 && page <= totalPages) {
      setCurrentPage(page);
      setPage(page);
      // Add any additional logic for page change here
    }
  };

  // Calculate the page numbers to display

  const handlePageSizeChange = (size) => {
    setPageSize(size);
    setPage(1);
  };

  const handleRoleGroupChange = (event) => {
    setSelectedRoleGroup(event.target.value);
  };

  const handleAddRole = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});
    try {


      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/role/create`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            role_group_id: selectedRoleGroup,
            role_code: newRole.role_code,
            role_name: newRole.role_name,
          }),
        },
        navigate // Pass navigate here if needed
      );



      setRoles((prevRoles) => [...prevRoles, data]);
      setShowAddModal(false);
      setNewRole({ role_group_id: "", role_code: "", role_name: "" });
      toast.success("Role added successfully");
    } catch (error) {
      setLoading(false); // Ensure loading state is reset in case of an error
      if (error.response) {
        const errorData = error.response;
        console.error(errorData);
        setErrors(errorData.errors || {});
        toast.error(errorData.message || "Error adding role");
      } else {
        console.error("Error adding role:", error);
        toast.error("Error adding role");
      }
    } finally {
      setLoading(false);
      fetchRoles();
    }
  };

  const handleEditRole = async (e) => {
    e.preventDefault();
    setLoading(true);
    setErrors({});

    try {
      const data = await fetchWrapper(
        `${process.env.REACT_APP_BASE_API_URL1}/api/v1/role/update/${selectedRole._id}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(selectedRole),
        },
        navigate // Pass navigate here if needed
      );



      const updatedRoles = roles.map((role) =>
        role._id === selectedRole._id ? data : role
      );
      setRoles(updatedRoles);
      setShowEditModal(false);
      setNewRole({ role_group_id: "", role_code: "", role_name: "" });
      toast.success("Role updated successfully");
    } catch (error) {
      setLoading(false); // Ensure loading state is reset in case of an error
      if (error.response) {
        const errorData = error.response;
        console.error(errorData);
        setErrors(errorData.errors || {});
        toast.error(errorData.message || "Error updating role");
      } else {
        console.error("Error updating role:", error);
        toast.error("Error updating role");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleToggleUserStatus = (roleId, currentStatus) => {
    setActionRoleId(roleId);
    setActionType(currentStatus ? "Inactive" : "Restore");
    setConfirmModal(true);
  };
  const confirmAction = async () => {
    setLoading(true);

    // Determine the endpoint based on the action type
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/role/delete/${actionRoleId}`;



    try {
      await fetchWrapper(
        url,
        {
          method: "POST",
        },
        navigate // Pass navigate here
      );

      setLoading(false);


      // Update the status of the role
      const updatedRoles = roles.map((role) =>
        role._id === actionRoleId
          ? { ...role, status: actionType === "Restore" ? true : false }
          : role
      );
      setRoles(updatedRoles); // Update the roles state
      setConfirmModal(false);

      if (actionType === "Inactive") {
        toast.success(`Role Inactive Successful`);
      } else {
        toast.success(`Role Restore Successful`);
      }
    } catch (error) {
      setLoading(false);
      console.error(`Error ${actionType} role:`, error);
      toast.error(`Error ${actionType} role`);
    }
  };

  const handleBulkDelete = async () => {
    setLoading(true);
    const url = `${process.env.REACT_APP_BASE_API_URL1}/api/v1/role/delete/${checkedItems[0]}`;

    try {
      await fetchWrapper(
        url,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            ids: checkedItems,
          }),
        },
        navigate // Pass navigate here
      );

      setLoading(false);


      const updatedRoles = roles.map((role) =>
        checkedItems.includes(role._id) ? { ...role, status: false } : role
      );

      setRoles(updatedRoles);
      setBulkDeleteModal(false);
      toast.success(`All the selected items are Inactivated successfully`);
      setAllChecked(!checkedItems);
      setCheckedItems([]);
    } catch (error) {
      setLoading(false);
      console.error(`Error deleting selected roles:`, error);
      toast.error(`Error deleting selected roles`);
    }
  };

  const handleStatusChange = (status) => {
    setStatusFilter(status === "all" ? "" : status);
    setPage(1); // Reset to the first page when changing status
  };

  const handleHeaderCheckboxChange = () => {
    const newCheckedStatus = !allChecked;
    setAllChecked(newCheckedStatus);
    if (newCheckedStatus) {
      setCheckedItems(
        roles.filter((role) => role.status).map((role) => role._id)
      );
    } else {
      setCheckedItems([]);
    }
  };

  const handleRowCheckboxChange = (roleId) => {
    setCheckedItems((prevCheckedItems) => {
      const isChecked = prevCheckedItems.includes(roleId);
      const updatedCheckedItems = isChecked
        ? prevCheckedItems.filter((id) => id !== roleId)
        : [...prevCheckedItems, roleId];

      setAllChecked(
        updatedCheckedItems.length ===
        roles.filter((role) => role.status).length
      );
      return updatedCheckedItems;
    });
  };

  useEffect(() => {
    fetchRoleGroups();
  }, []);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault(); // Prevent default behavior if needed
      fetchRoles(); // Perform search
    }
  };
  useEffect(() => {
    fetchRoles();
  }, [
    page,
    pageSize,
    sortBy,
    // search,
    //roles.length,
    showEditModal,
    statusFilter,
  ]);

  return (
    <>
      <div className="">
        <div className="container ">
          <div className="show-breadcrumb pt-3">
            <div className="">
              <h5 className="">Roles</h5>

              <nav className="breadcrumb-nav" aria-label="breadcrumb">
                <ol className="breadcrumb ">
                  <li className="breadcrumb-item ">
                    <a className="">Configure</a>
                  </li>
                  <li className="breadcrumb-item">
                    <a className="">User Settings</a>
                  </li>

                  <li className="breadcrumb-item active" aria-current="page">
                    Roles
                  </li>
                </ol>
              </nav>

              <div
                className="navbar-3 d-flex justify-content-between "
                style={{ marginTop: "-3px" }}
              >
                <div className="d-flex gap-3">
                  <div className="search-container ">
                    <img src={search2} alt="Search" />
                    <input
                      type="text"
                      className=""
                      id="search"
                      value={search}
                      onChange={handleSearchChange}
                      onKeyDown={handleKeyDown}
                      placeholder="Search "
                      name="search"
                      autoComplete="off"
                    />
                  </div>
                  {hasPermission(["roles.delete"]) && (
                    <div>
                      {checkedItems.length > 0 && (
                        <button
                          id="bulkDelete"
                          className="bulkDelete-btn"
                          style={{ display: "block" }}
                          onClick={() => setBulkDeleteModal(true)}
                        >
                          <span>
                            <img
                              src={recyclebin}
                              height="24px"
                              width="24px"
                              alt=""
                            />
                          </span>{" "}
                          Inactive
                        </button>
                      )}
                    </div>
                  )}
                </div>

                <div className="d-flex gap-3">
                  <div className="dropdown">
                    <select
                      id="cars"
                      className=" select-unit textarea "
                      value={statusFilter}
                      onChange={(e) => handleStatusChange(e.target.value)}
                      style={{
                        width: "120px",
                        height: "calc(100% - 1px)", // Adjust height to be 3px less
                      }}
                    >
                      <option value="">All</option>
                      <option value="active">Active</option>
                      <option value="inactive">Inactive</option>
                    </select>
                  </div>
                  {hasPermission(["roles.create"]) && (
                    <div>
                      <button
                        type="button"
                        id="openPopup"
                        className="btn-bg"
                        onClick={() => {
                          setErrors({});
                          setSelectedRoleGroup("");
                          setNewRole({
                            role_group_id: "",
                            role_code: "",
                            role_name: "",
                          });
                          setShowAddModal(true);
                        }}
                      // onClick={() => setShowAddModal(true)}
                      >
                        <span className="plus-icon">
                          <img src={plus1} alt="Plus Icon" />
                        </span>
                        Add Role
                      </button>
                    </div>
                  )}
                </div>
              </div>
              <div style={{ marginTop: "-10px" }}>
                <div className="table-responsive">
                  <table className="table align-middle table-text">
                    <thead className="table-head align-middle">
                      <tr>
                        <th className="table-check">
                          <input
                            type="checkbox"
                            checked={allChecked}
                            onChange={handleHeaderCheckboxChange}
                          />
                        </th>
                        <th className="col"> ID</th>

                        <th onClick={() => handleSortChange("role_code")}>
                          ROLE CODE{" "}
                          {sortBy.field === "role_code" && (
                            <span>
                              {sortBy.order === "asc" ? (
                                <img src={ArrowUp} alt="ArrowUp" />
                              ) : (
                                <img src={ArrowDown} alt="ArrowDown" />
                              )}
                            </span>
                          )}
                        </th>
                        <th onClick={() => handleSortChange("role_name")}>
                          ROLE NAME{" "}
                          {sortBy.field === "role_name" && (
                            <span>
                              {sortBy.order === "asc" ? (
                                <img src={ArrowUp} alt="ArrowUp" />
                              ) : (
                                <img src={ArrowDown} alt="ArrowDown" />
                              )}
                            </span>
                          )}
                        </th>
                        <th>
                          {/* <th onClick={() => handleSortChange("role_group_id")}> */}
                          ROLE GROUP{" "}
                          {/* {sortBy.field === "role_group_id" && (
                            <span>
                              {sortBy.order === "asc" ? (
                                <img src={ArrowUp} alt="ArrowUp" />
                              ) : (
                                <img src={ArrowDown} alt="ArrowDown" />
                              )}
                            </span>
                          )} */}
                        </th>
                        <th>STATUS</th>
                        {(hasPermission(["roles.update"]) ||
                          hasPermission(["roles.delete"])) && <th>ACTION</th>}
                      </tr>
                    </thead>
                    <tbody>
                      {roles.map((role, index) => (
                        <tr
                          key={role._id}
                          className={role.status ? "" : "disabled text-muted"}
                        >
                          <td className="table-check">
                            <input
                              type="checkbox"
                              checked={checkedItems.includes(role._id)}
                              onChange={() => handleRowCheckboxChange(role._id)}
                              disabled={!role.status}
                            />
                          </td>
                          <td>{index + startIndex}</td>
                          <td>{role.role_code}</td>
                          <td>{role.role_name}</td>
                          <td>
                            {roleGroups.find(
                              (group) => group._id === role.role_group_id
                            )?.role_group_name || "N/A"}
                          </td>
                          <td>
                            {role.status ? (
                              <span className="active-status">Active</span>
                            ) : (
                              <span className="inactive">Inactive</span>
                            )}
                          </td>
                          {(hasPermission(["roles.update"]) ||
                            hasPermission(["roles.delete"])) && (
                              <td>
                                <div className="action-icons d-flex justify-content-left align-items-center ">
                                  {role.status &&
                                    hasPermission(["roles.update"]) && (
                                      <button
                                        style={{
                                          border: "none",
                                          background: "transparent",
                                        }}
                                        className="align-content-center me-3"
                                        onClick={() => {
                                          setErrors({});
                                          setSelectedRole(role);
                                          setShowEditModal(true);
                                        }}
                                        disabled={!role.status}
                                      >
                                        <img src={edit} alt="edit" />
                                      </button>
                                    )}
                                  {hasPermission(["roles.delete"]) && (
                                    <span className="align-content-center switcher">
                                      <label className="switch switch1">
                                        <input
                                          type="checkbox"
                                          checked={role.status}
                                          onChange={() =>
                                            handleToggleUserStatus(
                                              role._id,
                                              role.status
                                            )
                                          }
                                        />
                                        <span className="slider slider1 round"></span>
                                      </label>
                                    </span>
                                  )}
                                </div>
                              </td>
                            )}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={handlePageChange}
                pageSize={pageSize}
                onPageSizeChange={handlePageSizeChange}
                totalItems={totalItems}
                startIndex={startIndex}
                endIndex={endIndex}
              />
            </div>
          </div>
        </div>
        {/* Add Role Modal */}
        <div
          id="overlay"
          className={`modal fade ${showAddModal ? "show" : ""}`}
          tabIndex="-1"
          role="dialog"
          style={{
            zIndex: 30,
            display: showAddModal ? "block" : "none",
            transition: "width 2s",
          }}
        >
          {loading ? (
            <Loader />
          ) : (
            <div>
              <div className="addunit-card Width 25%">
                <div className="addunit-header">
                  <h6 style={{ margin: "1vh", fontSize: "20px" }}>Add Role</h6>
                  <button
                    style={{ border: "none", backgroundColor: "inherit" }}
                    type="button"
                    className="close"
                    onClick={() => {
                      setSelectedRoleGroup("");
                      setNewRole({
                        role_group_id: "",
                        role_code: "",
                        role_name: "",
                      });
                      setShowAddModal(false);
                    }}
                  >
                    <img src={close} width="28px" height="28px" alt="Close" />
                  </button>
                </div>

                <form
                  onSubmit={handleAddRole}
                  autoComplete="off"
                  noValidate
                  className="needs-validation"
                >
                  <div className="addunit-form">
                    <div className="row">
                      <div className="d-flex flex-column mb-3 col">
                        <label
                          htmlFor="roleGroup"
                          className="addunit-form-text"
                        >
                          Select Role Group{" "}
                          <span className="text-danger"> *</span>
                        </label>
                        <select
                          className={`form-select select-unit textarea ${errors.role_group_id ? "is-invalid" : ""
                            }`}
                          value={selectedRoleGroup}
                          onChange={handleRoleGroupChange}
                        >
                          <option value="">Select Role Group</option>
                          {roleGroups.map((roleGroup) => (
                            <option key={roleGroup._id} value={roleGroup._id}>
                              {roleGroup.role_group_name}
                            </option>
                          ))}
                        </select>
                        {errors.role_group_id && (
                          <div className="invalid-feedback">
                            {errors.role_group_id}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="d-flex flex-column  mb-3">
                        <label htmlFor="roleCode" className="addunit-form-text">
                          Role Code <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.role_code ? "is-invalid" : ""
                            }`}
                          id="roleCode"
                          placeholder="Enter the Role Code"
                          value={newRole.role_code}
                          onChange={(e) =>
                            setNewRole({
                              ...newRole,
                              role_code: e.target.value,
                            })
                          }
                        />
                        {errors.role_code && (
                          <div className="invalid-feedback">
                            {errors.role_code}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="d-flex flex-column  mb-3">
                        <label htmlFor="roleName" className="addunit-form-text">
                          Role Name <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.role_name ? "is-invalid" : ""
                            }`}
                          id="roleName"
                          placeholder="Enter the Role Name"
                          value={newRole.role_name}
                          onChange={(e) =>
                            setNewRole({
                              ...newRole,
                              role_name: e.target.value,
                            })
                          }
                        />
                        {errors.role_name && (
                          <div className="invalid-feedback">
                            {errors.role_name}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => {
                        setSelectedRoleGroup("");
                        setNewRole({
                          role_group_id: "",
                          role_code: "",
                          role_name: "",
                        });
                        setShowAddModal(false);
                      }}
                    >
                      Close
                    </button>
                    <button type="submit" className="update-btn">
                      Add
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
        {/* Edit Role Modal */}
        <div
          id="overlay"
          className={`modal fade ${showEditModal ? "show" : ""}`}
          tabIndex="-1"
          role="dialog"
          style={{
            zIndex: 30,
            display: showEditModal ? "block" : "none",
            transition: "width 2s",
          }}
        >
          {loading ? (
            <Loader />
          ) : (
            <div>
              <div className="addunit-card Width 25%">
                <div className="addunit-header">
                  <h4>Edit Role</h4>
                  <button
                    style={{ border: "none", backgroundColor: "inherit" }}
                    type="button"
                    className="close"
                    onClick={() => setShowEditModal(false)}
                  >
                    <img src={close} width="28px" height="28px" alt="Close" />
                  </button>
                </div>

                <form
                  onSubmit={handleEditRole}
                  noValidate
                  className="needs-validation"
                >
                  <div className="addunit-form">
                    <div className="row">
                      <div className="d-flex flex-column  mb-4 col">
                        <label
                          htmlFor="roleGroup"
                          className="addunit-form-text"
                        >
                          Select Role Group
                          <span className="text-danger"> *</span>
                        </label>
                        <select
                          className={`form-select select-unit textarea ${errors.role_group_id ? "is-invalid" : ""
                            }`}
                          value={selectedRole?.role_group_id || ""}
                          onChange={(e) =>
                            setSelectedRole((prevRole) => ({
                              ...prevRole,
                              role_group_id: e.target.value,
                            }))
                          }
                        >
                          <option value="">Select Role Group</option>
                          {roleGroups.map((roleGroup) => (
                            <option key={roleGroup._id} value={roleGroup._id}>
                              {roleGroup.role_group_name}
                            </option>
                          ))}
                        </select>
                        {errors.role_group_id && (
                          <div className="invalid-feedback">
                            {errors.role_group_id}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="d-flex flex-column  mb-4">
                        <label
                          htmlFor="editRoleCode"
                          className="addunit-form-text"
                        >
                          Role Code <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.role_code ? "is-invalid" : ""
                            }`}
                          id="editRoleCode"
                          placeholder="Enter the Role Code"
                          value={selectedRole?.role_code || ""}
                          onChange={(e) =>
                            setSelectedRole({
                              ...selectedRole,
                              role_code: e.target.value,
                            })
                          }
                        />
                        {errors.role_code && (
                          <div className="invalid-feedback">
                            {errors.role_code}
                          </div>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="d-flex flex-column  mb-4">
                        <label
                          htmlFor="editRoleName"
                          className="addunit-form-text"
                        >
                          Role Name <span className="text-danger"> *</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${errors.role_name ? "is-invalid" : ""
                            }`}
                          id="editRoleName"
                          placeholder="Enter the Role Name"
                          value={selectedRole?.role_name || ""}
                          onChange={(e) =>
                            setSelectedRole({
                              ...selectedRole,
                              role_name: e.target.value,
                            })
                          }
                        />
                        {errors.role_name && (
                          <div className="invalid-feedback">
                            {errors.role_name}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="addunit-card-footer justify-content-between">
                    <button
                      type="button"
                      className="discard-btn"
                      onClick={() => setShowEditModal(false)}
                    >
                      Close
                    </button>
                    <button type="submit" className="update-btn">
                      Save Changes
                    </button>
                  </div>
                </form>
              </div>
            </div>
          )}
        </div>
        {/* Confirmation Modal */}
        <div
          id="overlay"
          className={`modal fade ${confirmModal ? "show" : ""}`}
          tabIndex="-1"
          role="dialog"
          style={{
            zIndex: 30,
            display: confirmModal ? "block" : "none",
            transition: "width 2s",
          }}
        >
          {loading ? (
            <Loader />
          ) : (
            <div>
              <div className="addunit-card Width 25%">
                <div className="addunit-header">
                  <h4>
                    {actionType === "Restore" ? "Restore" : "Inactivate"} Role
                  </h4>
                  <button
                    style={{ border: "none", backgroundColor: "inherit" }}
                    type="button"
                    className="close"
                    onClick={() => setConfirmModal(false)}
                  >
                    <img src={close} width="28px" height="28px" alt="Close" />
                  </button>
                </div>
                <div className="addunit-form">
                  <p>
                    Are you sure you want to{" "}
                    {actionType === "Restore" ? "restore" : "inactivate"} this
                    role?
                  </p>
                </div>
                <div className="addunit-card-footer justify-content-between">
                  <button
                    type="button"
                    className="discard-btn"
                    onClick={() => setConfirmModal(false)}
                  >
                    Cancel
                  </button>
                  <button
                    type="button"
                    className="update-btn"
                    onClick={confirmAction}
                  >
                    {actionType === "Restore" ? "Restore" : "Inactivate"}
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Bulk Delete Modal */}
        <div
          id="overlay"
          className={`modal fade ${bulkDeleteModal ? "show" : ""}`}
          tabIndex="-1"
          role="dialog"
          style={{
            zIndex: 30,
            display: bulkDeleteModal ? "block" : "none",
            transition: "width 2s",
          }}
        >
          {loading ? (
            <Loader />
          ) : (
            <div>
              <div className="addunit-card Width 25%">
                <div className="addunit-header">
                  <h4>Bulk Inactive</h4>
                  <button
                    style={{ border: "none", backgroundColor: "inherit" }}
                    type="button"
                    className="close"
                    onClick={() => setBulkDeleteModal(false)}
                  >
                    <img src={close} width="28px" height="28px" alt="Close" />
                  </button>
                </div>
                <div className="bulk-delete-unit">
                  <img src={recyclebin} width="48px" height="48px" />

                  <h4 className="delete-unit-h4">Inactive Roles</h4>
                  <p className="delete-unit-text">
                    Are you sure you want to inactive all the selected roles?
                  </p>
                </div>
                <div className="addunit-card-footer justify-content-between">
                  <button
                    type="button"
                    className="discard-btn"
                    onClick={() => setBulkDeleteModal(false)}
                  >
                    CANCEL
                  </button>
                  <button
                    type="button"
                    className="update-btn"
                    onClick={handleBulkDelete}
                  >
                    CONFIRM
                  </button>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <ToastContainer autoClose={2000} position={"top-right"} />
    </>
  );
};

export default Role;
